import cn from 'classnames';
import './DSRadio.scss';

export type DSRadioColor = 'theme' | 'green';

interface DSRadioProps {
	color?: DSRadioColor;
	enabled: boolean;
	onEnabled?: () => void;
	disabled?: boolean;
	label?: string;
}

export const DSRadio = ({ color = 'theme', ...props }: DSRadioProps) => {
	const ringClasses = () => {
		switch (color) {
			case 'theme':
				if (props.disabled) {
					return 'text-gray-250 dark:text-white dark:opacity-30';
				}

				return 'text-primary-400 group-hover:text-primary-500 dark:text-gray-100 dark:group-hover:text-gray-100';
			case 'green':
				if (props.disabled) {
					return 'text-white opacity-30';
				}

				return 'text-gray-100 group-hover:text-gray-100';
		}
	};

	const circleClasses = () =>
		cn(
			props.disabled
				? {
						'text-gray-250': color === 'theme',
						'text-white': color === 'green',
				  }
				: {
						'text-primary-400 dark:text-accent-500': color === 'theme',
						'text-gray-100': color === 'green',
				  },
		);

	const mainClasses = () =>
		cn(
			'group flex items-center gap-2',
			{ 'cursor-pointer': !props.disabled },
			{
				'dark:opacity-30': color === 'theme' && props.disabled,
				'opacity-30': color === 'green' && props.disabled,
			},
		);

	const labelClasses = () =>
		cn(
			'select-none',
			{
				'font-bold': props.enabled,
			},
			props.disabled
				? {
						'text-gray-300 dark:text-gray-100': color === 'theme',
						'text-gray-100': color === 'green',
				  }
				: {
						'text-gray-900 dark:text-gray-100': color === 'theme',
						'text-gray-100': color === 'green',
				  },
		);

	return (
		<div className={mainClasses()} onClick={() => !props.disabled && props.onEnabled?.()}>
			<div>
				<svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="12" cy="12" r="11" className={ringClasses()} stroke="currentColor" strokeWidth="2" />
					{props.enabled && <circle cx="12" cy="12" r="7" className={circleClasses()} fill="currentColor" />}
				</svg>
			</div>
			{props.label && (
				<div className={cn('radio-label', 'select-none', labelClasses())} title={props.label}>
					{props.label}
				</div>
			)}
		</div>
	);
};
